import { InteractionManager } from 'react-native';

export const OP_INLINE = 1;
export const OP_IMMEDIATE = 2;
export const OP_NEXT_DRAWFRAME = 3;
export const OP_NEAREST_IDLE_JS = 4;
export const OP_NEAREST_IDLE_INTERACTIVE = 5;

export const schedulers = {
    [OP_INLINE]: action => action(),
    [OP_IMMEDIATE]: setImmediate,
    [OP_NEXT_DRAWFRAME]: requestAnimationFrame,
    [OP_NEAREST_IDLE_JS]: typeof requestIdleCallback !== 'undefined'
    ? requestIdleCallback
    : handleFunc => {
          handleFunc && handleFunc();
      },
    [OP_NEAREST_IDLE_INTERACTIVE]: InteractionManager.runAfterInteractions,
};
